import { useMemo } from 'react';

import { useStoreAvailabilityFns } from 'features/store/hooks/use-store-availability-fns';
import { useIntl } from 'react-intl';

import { IRestaurant } from '@rbi-ctg/store';

interface UseErrorMessageOptions {
  restaurant: IRestaurant;
}

export const useErrorMessage = ({ restaurant }: UseErrorMessageOptions) => {
  const { formatMessage } = useIntl();
  const { isMobileOrderingAvailable, isPOSAvailable } = useStoreAvailabilityFns();

  return useMemo(() => {
    let errorMessage: string | undefined;
    if (!isMobileOrderingAvailable(restaurant) || !isPOSAvailable(restaurant)) {
      errorMessage = formatMessage({ id: 'mobileOrderingUnavailable' });
    }

    return errorMessage;
  }, [formatMessage, isMobileOrderingAvailable, isPOSAvailable, restaurant]);
};
